import { SetStateAction } from 'react'

import copy from 'copy-to-clipboard'

import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

const copyUrl = (setIsSaved: { (value: SetStateAction<boolean>): void }, moduleUrl: string) => {
  const url = moduleUrl
  if (url && copy(url)) {
    app.setFlash({
      type: 'correct',
      message: i18n.t('marketplace.modules.sharing_area.flash_message'),
    })

    setIsSaved(true)

    setTimeout(() => {
      setIsSaved(false)
    }, 3000)
  }
}

export default copyUrl
